import { useParams, useNavigate } from "react-router-dom";
import { LEGAL } from "@/data/legalContent";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function Legal({ doc: docProp }) {
  const { doc: docParam } = useParams();
  const doc = docProp || docParam;
  const navigate = useNavigate();
  const { lang, t } = useI18n();
  const key = LEGAL[doc] ? doc : "privacy";
  const content = LEGAL[key][lang] || LEGAL[key].en;

  const docs = [
    { k: "privacy", label: t("settings.privacy") },
    { k: "terms", label: t("settings.terms") },
    { k: "ai-notice", label: t("settings.aiNotice") },
    { k: "delete-account", label: t("legal.deleteAccountTab") },
  ];

  return (
    <div className="min-h-screen bg-surface-0" data-testid="legal-page">
      <header className="border-b border-white/10 sticky top-0 bg-surface-0/90 backdrop-blur z-30">
        <div className="mx-auto max-w-[820px] px-4 md:px-8 h-16 flex items-center justify-between">
          <button onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))} className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft style={{ width: 16, height: 16 }} /> {t("common.back")}
          </button>
          <Logo size="sm" />
        </div>
      </header>

      <div className="mx-auto max-w-[820px] px-4 md:px-8 py-10 pb-24">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <div className="flex flex-wrap gap-2">
            {docs.map((d) => (
              <Button key={d.k} size="sm" variant={key === d.k ? "default" : "outline"} onClick={() => navigate(`/${d.k}`)}
                className={key === d.k ? "bg-cyan-400 text-slate-900 hover:bg-cyan-300" : "border-white/15 bg-white/5 hover:bg-white/10"}>
                {d.label}
              </Button>
            ))}
          </div>
          <LangToggle data-testid="legal-language-toggle" />
        </div>

        <article className="card-base p-6 md:p-8">
          <h1 className="text-2xl md:text-3xl font-display font-semibold tracking-tight">{content.title}</h1>
          <p className="text-sm text-muted-foreground mt-1 mb-6">{content.updated}</p>
          <div className="space-y-6 max-w-prose">
            {content.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display font-semibold text-lg mb-1.5">{s.h}</h2>
                <p className="text-sm md:text-base text-muted-foreground leading-7">{s.p}</p>
              </section>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
}
